// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleMode } from './VehicleMode';
import {
    VehicleModeFromJSON,
    VehicleModeFromJSONTyped,
    VehicleModeToJSON,
    VehicleModeToJSONTyped,
} from './VehicleMode';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
    LinksToJSONTyped,
} from './Links';
import type { Point } from './Point';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
    PointToJSONTyped,
} from './Point';
import type { Place } from './Place';
import {
    PlaceFromJSON,
    PlaceFromJSONTyped,
    PlaceToJSON,
    PlaceToJSONTyped,
} from './Place';

/**
 * A place (de:Haltestelle) comprising one or more areas where vehicles may stop and where passengers may board or leave vehicles or prepare their trip. The name is given in regional language only.<br>Inherited from `Place`.
 * @export
 * @interface StopPlace
 */
export interface StopPlace extends Place {
    /**
     * Swiss location id (SLOID) from Atlas. More on [Service Points (Atlas) API](https://developer.sbb.ch/apis/atlas/documentation) > GET /service-point-directory/v1/service-points.
     * @type {string}
     * @memberof StopPlace
     */
    swissLocationId?: string;
    /**
     * Boundary for fare calculation resp. whether the **stop represents a tariff border between Switzerland and a neighbouring country**, where _true_ is based on a NOVA Tariff-BorderPoint (and must not be missunderstand by [UIC borderpoints](https://uic.org/support-activities/it/article/border-points).
     * @type {boolean}
     * @memberof StopPlace
     */
    tariffBorder: boolean;
    /**
     * The higher the traffic load/importance the higher the value, null if unknown.
     * @type {number}
     * @memberof StopPlace
     */
    weighting?: number;
    /**
     * 
     * @type {Set<VehicleMode>}
     * @memberof StopPlace
     */
    vehicleModes: Set<VehicleMode>;
    /**
     * 
     * @type {Links}
     * @memberof StopPlace
     */
    links?: Links;
}

/**
 * Check if a given object implements the StopPlace interface.
 */
export function instanceOfStopPlace(value: object): value is StopPlace {
    if (!('tariffBorder' in value) || value['tariffBorder'] === undefined) return false;
    if (!('vehicleModes' in value) || value['vehicleModes'] === undefined) return false;
    return true;
}

export function StopPlaceFromJSON(json: any): StopPlace {
    return StopPlaceFromJSONTyped(json, false);
}

export function StopPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StopPlace {
    if (json == null) {
        return json;
    }
    return {
        ...PlaceFromJSONTyped(json, true),
        'swissLocationId': json['swissLocationId'] == null ? undefined : json['swissLocationId'],
        'tariffBorder': json['tariffBorder'],
        'weighting': json['weighting'] == null ? undefined : json['weighting'],
        'vehicleModes': (new Set((json['vehicleModes'] as Array<any>).map(VehicleModeFromJSON))),
        'links': json['links'] == null ? undefined : LinksFromJSON(json['links']),
    };
}

  export function StopPlaceToJSON(json: any): StopPlace {
      return StopPlaceToJSONTyped(json, false);
  }

  export function StopPlaceToJSONTyped(value?: StopPlace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...PlaceToJSONTyped(value, true),
        'swissLocationId': value['swissLocationId'],
        'tariffBorder': value['tariffBorder'],
        'weighting': value['weighting'],
        'vehicleModes': (Array.from(value['vehicleModes'] as Set<any>).map(VehicleModeToJSON)),
        'links': LinksToJSON(value['links']),
    };
}

